























import { defineComponent, computed } from "vue";

import UiMenu from "@dpa-id-components/ui-menu";
import UiList from "@dpa-id-components/ui-list";
import UiListItem from "@dpa-id-components/ui-list-item";

import { useRoute, useRouter } from "vue-router/composables";
import getCurrentView from "@/composition/getCurrentView";
import useMatomoEvent from "@/composition/useMatomoEvent";

export default defineComponent({
  components: {
    UiMenu,
    UiList,
    UiListItem
  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    const query = computed(() => route.query);

    const params = computed(() => route.params);

    const getRouteForSortOrder = (sortOrder = "desc") => {
      return {
        params: params.value,
        query: {
          ...query.value,
          sortOrder
        }
      };
    };

    const items = computed(() => {
      return [
        {
          label: "latestFirst",
          selected: route.query.sortOrder === "desc",
          to: getRouteForSortOrder("desc"),
          matomoEvent: {
            category: `${getCurrentView()} View`,
            name: "Change sorting-options to 'Neueste zuerst'",
            action: "Click 'Neueste zuerst' after 'Älteste zuerst' was active"
          }
        },
        {
          label: "oldestFirst",
          selected: route.query.sortOrder === "asc",
          to: getRouteForSortOrder("asc"),
          matomoEvent: {
            category: `${getCurrentView()} View`,
            name: "Change sorting-options to 'Älteste zuerst'",
            action: "Click 'Älteste zuerst' after 'Neueste zuerst' was active"
          }
        }
      ];
    });

    const selectedLabel = computed(() => {
      const found = items.value.find(item => item.selected);

      if (found && found.label) {
        return found.label;
      }

      return "";
    });

    const trackSortOptionsOpen = () => {
      useMatomoEvent({
        category: `${getCurrentView()} View`,
        name: "Sorting Options",
        action: "Open dropdown for sorting-options"
      });
    };

    return {
      items,
      router,
      selectedLabel,
      trackSortOptionsOpen,
      useMatomoEvent
    };
  }
});
